import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import UserQRCode from "../../../containers/admin/students/models/user-qr-code";
import SearchBar from "../../../containers/superadmin/videos-requests/searchbar";
import VideosRequestTable from "../../../containers/superadmin/videos-requests/table";
import { getAllRequestsRequest } from "../../../modules/superadmin-modules/video-requests/Actions";

const VideosMoreViewRequests = () => {
  const dispatch = useDispatch();
  const model = useSelector((state) => state.model);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  useEffect(() => {
    dispatch(getAllRequestsRequest());
  }, []);

  return (
    <Layout>
      <SearchBar setAdd={setAdd} setSelectedData={setSelectedData} />
      <VideosRequestTable setAdd={setAdd} setSelectedData={setSelectedData} />
      <UserQRCode
        data={selectedData?.student}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default VideosMoreViewRequests;
